export const vehicleModes = [
    'Self Bike',
    'Self Car',
    'Bike Rent',
    'Car Rent',
    'Pillion on bike',
    'Co-passenger in car'
];

export const comfortableOptions = ['Yes', 'No'];
